import type { QuestionMeasure } from '@/domain/model/measures'

const DEFAULT_MAX_THRESHOLD = 10

export const getMaxThreshold = (data?: QuestionMeasure) => {
  const measures = data?.measures
  const levels = data?.levels

  const allAnswer = levels?.map((level) => Number(level.threshold))
  const allThresholds = measures?.map((level) => Number(level.answer_value))

  const maxAnswer = allAnswer?.length ? Math.max(...allAnswer) : 0
  const maxThresholds = allThresholds?.length ? Math.max(...allThresholds) : 0

  const maxValue = Math.max(maxAnswer, maxThresholds)

  return Math.max(maxValue + 2, DEFAULT_MAX_THRESHOLD)
}
